import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var SubQuestionIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M5.94 2c.6 0 1.055.397 1.055.997V14c0 1.7 1.288 3 2.988 3H16.6l-2.3-2.3c-.4-.4-.4-1 0-1.4.2-.2.4-.3.7-.3.3 0 .5.1.7.3l4 4c.1.1.164.197.2.3.036.103.078.243.075.392-.004.13-.033.3-.075.408-.042.108-.1.2-.2.3l-4 4c-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4l2.3-2.3H9.983c-2.8 0-4.964-2.2-4.964-5V2.997c0-.6.322-.997.922-.997z",
                        fillRule: "evenodd"
                    })
                })
            })
        ]
    });
};
SubQuestionIcon.isCarinaIcon = true;
export default SubQuestionIcon;
